import React from 'react';
import { adminUser_listAdmins_data, Permission, updateUserPermissionsVariables } from '@api/graphql/types';
import { getError, AllFormErrors, EmptyFormErrors, getAllFormErrors } from '@root/utils/ErrorHelper';
import Notification from '@components/Notification';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import * as Mutations from '@api/graphql/mutations';
import GraphQLClient from '@api/graphql/GraphQLClient';
import InputCheckbox from '@components/Form/InputCheckbox';
import ButtonSave from '@components/Form/ButtonSave';

interface Props {
    user: adminUser_listAdmins_data;
}

interface State {
    formData: updateUserPermissionsVariables;
    allFormErrors: AllFormErrors;
}

type PropType = Props & InjectedIntlProps;

const PermissionMap: Permission[] = [
    Permission.MANAGE_ORDERS,
    Permission.MANAGE_USERS,
    Permission.LOGIN_AS_USER,
    Permission.MANAGE_USER_DISCOUNTS,
//  Permission.MANAGE_PRODUCT_VOTES,
    Permission.MANAGE_ADMINS,
    Permission.MANAGE_PRODUCTS,
    Permission.MANAGE_PRODUCT_ATTRIBUTES,
    Permission.MANAGE_PRODUCT_CATEGORIES,
    Permission.MANAGE_DONATIONS,
    Permission.MANAGE_COUPONS,
    Permission.MANAGE_BANNERS,
    Permission.MANAGE_PRODUCT_LIST_ADS,
    Permission.MANAGE_CMS,
    Permission.MANAGE_SHIPPING,
    Permission.MANAGE_TIMETABLES,
    Permission.MANAGE_DASHBOARD,
    Permission.MANAGE_PAYMENTS,
    Permission.MANAGE_URL_ALIASES,
];


class PermissionsForm extends React.Component<PropType, State> {
    public constructor(props: PropType) {
        super(props);
        this.state = {
            formData: {
                id: props.user.id,
                permissions: props.user.granted_permissions,
            },
            allFormErrors: EmptyFormErrors,
        };
    }

    private onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        GraphQLClient.mutate({
            mutation: Mutations.updateUserPermissions,
            variables: this.state.formData,
        }).then(() => {
            return Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
        }).catch((e: any) => {
            const allFormErrors = getAllFormErrors(e);
            this.setState({allFormErrors});

            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    public render() {
        const error = getError("permissions", this.state.allFormErrors);
        return (
            <form className="form-horizontal" onSubmit={this.onSubmit}>
                <div className={`form-group row ${error ? 'has-error' : ''}`}>
                    <label className="col-sm-2 col-form-label">{this.props.intl.formatMessage({ id: 'module.adminUser.permissions.title' })}</label>
                    <div className="col-sm-9">
                        <ul>
                            {PermissionMap.map(permission => {
                                return (
                                    <InputCheckbox
                                        name={Permission[permission]}
                                        key={permission}
                                        label={this.props.intl.formatMessage({id: `module.adminUser.permissions.${Permission[permission]}`})}
                                        onChangeHandler={(value: boolean, name: string) => {
                                            const permissions = [...this.state.formData.permissions];
                                            const isAdd = !this.state.formData.permissions.includes((name as Permission));
                                            const newPermissions = isAdd ?
                                                [...permissions, (name as Permission)] :
                                                permissions.filter((p: Permission) => p !== name);
                                            this.setState({formData: {...this.state.formData, permissions: newPermissions}});
                                        }}
                                        value={this.state.formData.permissions.includes(Permission[permission])}
                                    />
                                );
                            })}
                        </ul>
                    </div>
                    <div className="col-sm-1">
                        <ButtonSave type="submit" />
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
)(PermissionsForm);



// WEBPACK FOOTER //
// ./src/modules/AdminUser/components/PermissionsForm.tsx